var url = require('url')
const { jsonApiURL, oauth } = require('patreon')

// Use the client id and secret you received when setting up your OAuth account
var CLIENT_ID = 'jOK9oF552mg9SsR8re7q2S0Y3XqZR3jN9Usq4cTgbqvI8YXLA5X3Chcu6bs_xem_'
var CLIENT_SECRET = 'sJ617ETIyUzaR7IY91NOVDGmXCdFVNuym2As6uCzp2B15y9H3oIBCOoUetK1ssFV'
var patreonOAuth = oauth(CLIENT_ID, CLIENT_SECRET)

var redirectURL = 'https://backend.chorechampion.com:1337/handlePatreon'
window.handleOAuthRedirectRequest = handleOAuthRedirectRequest
export async function getLoginUrl() {
    const retVal = await url.format({
        protocol: 'https',
        host: 'patreon.com',
        pathname: '/oauth2/authorize',
        query: {
            response_type: 'code',
            client_id: CLIENT_ID,
            redirect_uri: redirectURL,
            state: 'chill'
        }
    })
    return retVal
}


export function handleOAuthRedirectRequest(code) {
    return new Promise((resolve, reject) => {
        patreonOAuth.getTokens(code, redirectURL).then(x => {
            (jsonApiURL(x.access_token))('/current_user')
        }).then(({ store }) => {
            resolve(store.findAll('user').map(user => user.serialize()))
        }).catch(x => reject(x))

    })
}